<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Update Customer Info</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <template v-if="pageReady">
                    <div class="grid">
                      <div class="col-12">
                        <form
                          ref="observer"
                          tag="form"
                          @submit.prevent="submitForm()"
                          class=""
                          :class="{ card: !isSubPage }"
                        >
                          <!--[form-content-start]-->
                          <div class="grid mx-1">
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Primary Telephone *
                              </div>
                              <div id="ctrl-client_id">
                                <InputText
                                  ref="ctrlclient_id"
                                  v-model.trim="formData.client_id"
                                  label="Primary Number"
                                  type="text"
                                  placeholder="Primary Number"
                                  class="w-full"
                                  pattern="^[0-9]+$"
                                  maxlength="12"
                                  minlength="10"
                                  :disabled="true"
                                  v-tooltip.top.focus="'Eg: 233209013836'"
                                  :class="getErrorClass('client_id')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('client_id')"
                                  class="p-error"
                                  >{{ getFieldError("client_id") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Secondary Telephone
                              </div>
                              <div id="ctrl-phone_number">
                                <InputText
                                  ref="ctrlphone_number"
                                  v-model.trim="formData.phone_number"
                                  label="Secondary Number"
                                  type="text"
                                  placeholder="Secondary Number"
                                  class="w-full"
                                  pattern="^[0-9]+$"
                                  maxlength="12"
                                  minlength="10"
                                  v-tooltip.top.focus="'Eg: 233209013836'"
                                  :class="getErrorClass('phone_number')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('phone_number')"
                                  class="p-error"
                                  >{{ getFieldError("phone_number") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                First Name *
                              </div>
                              <div id="ctrl-first_name">
                                <InputText
                                  ref="ctrlfirst_name"
                                  v-model.trim="formData.first_name"
                                  label="First Name"
                                  type="text"
                                  placeholder="First Name"
                                  class="w-full"
                                  pattern="^[A-Za-z-' ]+$"
                                  :class="getErrorClass('first_name')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('first_name')"
                                  class="p-error"
                                  >{{ getFieldError("first_name") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Last Name
                              </div>
                              <div id="ctrl-last_name">
                                <InputText
                                  ref="ctrllast_name"
                                  v-model.trim="formData.last_name"
                                  label="Last Name"
                                  type="text"
                                  placeholder="Last Name"
                                  class="w-full"
                                  pattern="^[A-Za-z-' ]+$"
                                  :class="getErrorClass('last_name')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('last_name')"
                                  class="p-error"
                                  >{{ getFieldError("last_name") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Primary Email
                              </div>
                              <div id="ctrl-primary_email">
                                <InputText
                                  ref="ctrlprimary_email"
                                  v-model.trim="formData.primary_email"
                                  label="Primary Email"
                                  type="email"
                                  maxlength="40"
                                  placeholder="Primary Email"
                                  class="w-full"
                                  :class="getErrorClass('primary_email')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('primary_email')"
                                  class="p-error"
                                  >{{ getFieldError("primary_email") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Fax Number
                              </div>
                              <div id="ctrl-fax_number">
                                <InputText
                                  ref="ctrlfax_number"
                                  v-model.trim="formData.fax_number"
                                  label="Fax Number"
                                  type="text"
                                  placeholder="Fax Number"
                                  pattern="^[A-Za-z0-9-',_. ]+$"
                                  class="w-full"
                                  :class="getErrorClass('fax_number')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('fax_number')"
                                  class="p-error"
                                  >{{ getFieldError("fax_number") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">City</div>
                              <div id="ctrl-city">
                                <InputText
                                  ref="ctrlcity"
                                  v-model.trim="formData.city"
                                  label="City"
                                  type="text"
                                  placeholder="City"
                                  pattern="^[A-Za-z0-9-',_. ]+$"
                                  class="w-full"
                                  :class="getErrorClass('city')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('city')"
                                  class="p-error"
                                  >{{ getFieldError("city") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">Address</div>
                              <div id="ctrl-address">
                                <InputText
                                  ref="ctrladdress"
                                  v-model.trim="formData.address"
                                  label="Address"
                                  type="text"
                                  pattern="^[A-Za-z0-9-',_. ]+$"
                                  placeholder="Address"
                                  class="w-full"
                                  :class="getErrorClass('address')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('address')"
                                  class="p-error"
                                  >{{ getFieldError("address") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Digital Address
                              </div>
                              <div id="ctrl-digital_address">
                                <InputText
                                  ref="ctrldigital_address"
                                  v-model.trim="formData.digital_address"
                                  label="Digital Address"
                                  type="text"
                                  pattern="^[a-zA-Z]{2}[0-9-]+$"
                                  maxlength="14"
                                  placeholder="Digital Address"
                                  class="w-full"
                                  :class="getErrorClass('digital_address')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('digital_address')"
                                  class="p-error"
                                  >{{ getFieldError("digital_address") }}</small
                                >
                              </div>
                            </div>
                          </div>

                          <!--[form-content-end]-->
                          <div v-if="showSubmitButton" class="text-center my-3">
                            <Button
                              type="submit"
                              label="Update"
                              icon="pi pi-send"
                              :loading="saving"
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 50px; height: 50px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, email } from "@/services/validators";
import { useApp } from "@/composables/app.js";
import { useEditPage } from "@/composables/editpage.js";
const props = defineProps({
  id: [String, Number],
  pageName: {
    type: String,
    default: "clients",
  },
  routeName: {
    type: String,
    default: "clientsedit",
  },
  pagePath: {
    type: String,
    default: "clients/edit",
  },
  apiPath: {
    type: String,
    default: "clients/edit",
  },
  submitButtonLabel: {
    type: String,
    default: "Update",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgAfterUpdate: {
    type: String,
    default: "Record updated successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp();
const formDefaultValues = Object.assign(
  {
    client_id: "",
    phone_number: "",
    first_name: "",
    last_name: "",
    primary_email: "",
    fax_number: "",
    city: "",
    address: "",
    digital_address: "",
  },
  props.pageData
);
const formData = reactive({ ...formDefaultValues });
function onFormSubmited(response) {
  app.flashMsg(props.msgAfterUpdate);
  //   if (props.redirect) app.navigateTo(`/clients`);
}
const rules = computed(() => {
  return {
    client_id: { required },
    phone_number: {},
    first_name: { required },
    last_name: {},
    primary_email: { email },
    fax_number: {},
    city: {},
    address: {},
    digital_address: {},
  };
});
const v$ = useVuelidate(rules, formData); //form validation
const page = useEditPage(props, formData, v$, onFormSubmited);
//page state
const {
  submitted, // form api submitted state - Boolean
  saving, // form api submiting state - Boolean
  loading, // form data loading state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // get editable form data from api
  submitForm, // submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;
onMounted(() => {
  const pageTitle = "Edit Clients";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
